// extracted by mini-css-extract-plugin
module.exports = {"children":"Tooltip_children__Cd2u1","disabled":"Tooltip_disabled__DpcL9","tooltip":"Tooltip_tooltip__KH6mE","arrow":"Tooltip_arrow__esjNY"};